export const ScriptStepPermissionConfigOptionDef = {
  accessibleByAll: 'accessibleByAll',
  notShared: 'notShared',
  specificShare: 'specificShare',
};

export const ScriptStepPermissionDef = {
  notShared: 'NOT_SHARED',
  canUse: 'CAN_USE',
  canEdit: 'CAN_EDIT',
  owner: 'OWNER',
};

export const ScriptStepSubjectDef = {
  allUsers: 'ALL_USERS',
  group: 'GROUP',
  person: 'PERSON',
  role: 'ROLE',
};
